import React, { useState, useEffect } from "react";
import { Box, Typography, Container, Autocomplete, TextField, Button } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import { DecorativeCorner } from "../../common/DecorativeCorner";
import { styles } from "../../styles/styles";
import {
	StyledTextField,
	StyledFormControl,
	FormContainer,
	StyledButton,
	FormGrid,

} from "../../common/FormStyles";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/material.css";
import { CircularProgress, } from "@mui/material";
import { InputLabel, MenuItem, Select } from "@mui/material";
import {
	getEducationList,
	getUniversitiesList,
	getProfessionList,
	getDesignationList,
	getEmployedInList,
	getCountriesList,
	getStatesList,
	getDistrictsList,
	updateEducationDetails,
	getProfileDetails,
	getHealthConditionList,
	getDistrictsListByState,
	updateNewJobDetails,
	getStatesListByCountry,
	getVisaTypes,
} from "../../../services/operations/userOperations";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import CustomAlert from "../../common/CustomAlert";
import { setFormData, getFormData } from "../../../utils/localStorageManager";
import dayjs from "dayjs";

const SKILLS_LIST = [
	{ id: 1, name: "Web Development" },
	{ id: 2, name: "Mobile Development" },
	{ id: 3, name: "UI/UX Design" },
	{ id: 4, name: "Project Management" },
	{ id: 5, name: "Data Analysis" },
	{ id: 6, name: "Digital Marketing" },
	{ id: 7, name: "Cloud Computing" },
	{ id: 8, name: "Artificial Intelligence" },
	{ id: 9, name: "Machine Learning" },
	{ id: 10, name: "Cybersecurity" },
];

const workingStatus = [{ id: "employed", name: "Employed" }, { id: "unEmployed", name: "Un Employed" }]

const EducationJobForm = (props) => {
	const location = useLocation();
	const { type,onSubmitSuccess } = props
	const navigate = useNavigate();
	const [educationList, setEducationList] = useState([]);
	const [selectedEducation, setSelectedEducation] = useState(null);
	const [universities, setUniversities] = useState([]);
	const [selectedUniversity, setSelectedUniversity] = useState(null);
	const [professions, setProfessions] = useState([]);
	const [selectedProfession, setSelectedProfession] = useState(null);
	const [designations, setDesignations] = useState([]);
	const [selectedDesignation, setSelectedDesignation] = useState(null);
	const [selectedEmployedStatus, setSelectedEmployedStatus] = useState(null);
	const [employedInList, setEmployedInList] = useState([]);
	const [countries, setCountries] = useState([]);
	const [states, setStates] = useState([]);
	const [districts, setDistricts] = useState([]);
	const [selectedEmployedIn, setSelectedEmployedIn] = useState(null);
	const [selectedCountry, setSelectedCountry] = useState(null);
	const [selectedState, setSelectedState] = useState(null);
	const [selectedDistrict, setSelectedDistrict] = useState(null);
	const [passportNumber, setPassportNumber] = useState("");
	const [visaType, setVisaType] = useState(null);
	const [workingCompany, setWorkingCompany] = useState("");
	const [instituteName, setInstituteName] = useState("");
	const [propertyDetails, setPropertyDetails] = useState("");
	const [annualIncome, setAnnualIncome] = useState("");
	const [visaValidityFrom, setVisaValidityFrom] = useState(dayjs());
	const [visaValidityTill, setVisaValidityTill] = useState(dayjs());
	const [workingSince, setWorkingSince] = useState(dayjs())
	const [errors, setErrors] = useState({});
	const [alert, setAlert] = useState({
		open: false,
		message: "",
		severity: "success",
	});
	const [workingLocation, setWorkingLocation] = useState(""); // Add this line
	const [totalExperience, setTotalExperience] = useState("");
	const [colleaguesInfo, setColleaguesInfo] = useState("");
	const [currentEmployer, setCurrentEmployer] = useState("");
	const [previousEmployer, setPreviousEmployer] = useState("");
	const [selectedSkills, setSelectedSkills] = useState([]);
	const [healthConditionsList, setHealthConditionsList] = useState([]);
	const [healthCondition, setHealthCondition] = useState(null); // Add this state variable
	const [officeLocation, setOfficeLocation] = useState("")
	const [aboutEducation, setAboutEducation] = useState("")
	const [visatypes, setVisaTypes] = useState([])
	let userType = sessionStorage.getItem("userType")
	let token
	if (userType) {
		token = sessionStorage.getItem("token");
	} else {
		token = localStorage.getItem("token");
	}
	// Add new function to fetch states when country is selected

	// Add visa type mapping
	const visaTypeMap = {
		tourist: 1,
		business: 2,
		work: 3,
		student: 4,
		permanent: 5,
	};

	useEffect(() => {
		const fetchEducationList = async () => {
			try {
				const response = await getEducationList();
				if (response.status) {
					setEducationList(response.data);
				}
			} catch (error) {
				console.error("Error fetching education list:", error);
			}
		};

		const fetchUniversities = async () => {
			try {
				const response = await getUniversitiesList();
				if (response.status) {
					setUniversities(response.data);
				}
			} catch (error) {
				console.error("Error fetching universities:", error);
			}
		};

		const fetchProfessions = async () => {
			try {
				const response = await getProfessionList();
				if (response.status) {
					setProfessions(response.data);
				}
			} catch (error) {
				console.error("Error fetching professions:", error);
			}
		};

		const fetchDesignations = async () => {
			try {
				const response = await getDesignationList();
				if (response.status) {
					setDesignations(response.data);
				}
			} catch (error) {
				console.error("Error fetching designations:", error);
			}
		};

		const fetchAdditionalData = async () => {
			if (token) {
				try {
					const [employedInResponse, countriesResponse, healthResponse] =
						await Promise.all([
							getEmployedInList(),
							getCountriesList(),
							getHealthConditionList(),
						]);

					if (employedInResponse.status)
						setEmployedInList(employedInResponse.data);
					if (countriesResponse.status) setCountries(countriesResponse.data);
					if (healthResponse.status) {
						console.log("Health conditions:", healthResponse.data); // Debug log
						setHealthConditionsList(healthResponse.data);
					}
				} catch (error) {
					console.error("Error fetching additional data:", error);
				}
			}
		};

		if (token) {
			fetchEducationList();
			fetchUniversities();
			fetchProfessions();
			fetchDesignations();
			fetchAdditionalData();
		}
	}, [type]);


	const [profileData, setProfileData] = useState(null);

	useEffect(() => {
		const fetchProfile = async () => {
			try {
				const response = await getProfileDetails();
				if (response.status) {
					setProfileData(response.data);
				}
			} catch (error) {
				console.error("Error fetching profile details:", error);
			}
		};

		fetchProfile();
	}, [type]);
	const skillIds = profileData?.jobDetails?.skills
		? profileData.jobDetails.skills.split(',').map((id) => Number(id))
		: [];

	useEffect(() => {
		const fetchAllData = async () => {
			try {
				// Fetch all necessary data in parallel
				const [
					educationResponse,
					universitiesResponse,
					professionsResponse,
					designationsResponse,
					employedInResponse,
					countriesResponse,
					healthResponse,
					profileResponse,
					statesResponse,
					visatyResponse,
					cityResponse,
				] = await Promise.all([
					getEducationList(),
					getUniversitiesList(),
					getProfessionList(),
					getDesignationList(),
					getEmployedInList(),
					getCountriesList(),
					getHealthConditionList(),
					getProfileDetails(),
					getStatesList(),
					getVisaTypes(),
					getDistrictsList(),

				]);

				// Set all dropdown options
				if (educationResponse.status) setEducationList(educationResponse.data);
				if (universitiesResponse.status) setUniversities(universitiesResponse.data);
				if (professionsResponse.status) setProfessions(professionsResponse.data);
				if (designationsResponse.status) setDesignations(designationsResponse.data);
				if (employedInResponse.status) setEmployedInList(employedInResponse.data);
				if (countriesResponse.status) setCountries(countriesResponse.data);
				if (healthResponse.status) setHealthConditionsList(healthResponse.data);
				if (statesResponse.status) setStates(statesResponse.data);
				// if (visatyResponse.status) setVisaType(visatyResponse.data);
				if (cityResponse.status) setDistricts(cityResponse.data);
				// Populate form with profile data if available
				if (profileResponse.status && profileResponse.data) {
					const { educationDetails, jobDetails } = profileResponse?.data;
					setProfileData(profileResponse?.data);

					// Education Details
					if (educationDetails) {
						setSelectedEducation(educationDetails?.education || null);
						setSelectedUniversity(educationDetails?.university || null);
						setSelectedProfession(educationDetails?.profession || null);
						setInstituteName(educationDetails?.institutionName || "");
						setAboutEducation(educationDetails?.aboutEducation || "")
					}

					// Job Details
					if (jobDetails) {
						// setSelectedDesignation(
						//   designationsResponse.data?.find(des => des.id === jobDetails.designation) || null
						// );

						setSelectedCountry(jobDetails?.country ?? countries.find((item) => item.id === jobDetails?.country?.id))
						setSelectedState(jobDetails?.state ?? states.find((item) => item.id === jobDetails?.state?.id)
)
						setSelectedDesignation(
							typeof jobDetails?.designation === 'object'
								? designationsResponse.data?.find(des => des.id === jobDetails?.designation?.id) || null
								: designationsResponse.data?.find(des => des.id === jobDetails?.designation) || null
						);
						setSelectedEmployedIn(
							employedInResponse.data?.find(emp => emp.id === jobDetails?.employedIn) || null
						);

						setWorkingCompany(jobDetails?.companyName || "");
						setAnnualIncome(jobDetails?.annualIncome?.toString() || "");
						setPropertyDetails(jobDetails?.propertyDetails || "");
						setCurrentEmployer(jobDetails?.currentEmployer || "");
						setPreviousEmployer(jobDetails?.previousEmployer || "");
						setOfficeLocation(jobDetails?.officeLocation || "");
						setTotalExperience(jobDetails?.totalExperience || "");
						setColleaguesInfo(jobDetails?.colleagueNameAndmobileNumber || "");
						setWorkingLocation(jobDetails?.workingLocationName || "");
						setSelectedEmployedStatus(workingStatus.find((each) => each?.name == jobDetails?.employedStatus) || null)
						setVisaType(jobDetails?.visaTypes || null)
						setPassportNumber(jobDetails?.passportNumber || "")

						// Health Condition
						setHealthCondition(
							healthResponse.data?.find(h => h.id === jobDetails?.healthCondition?.id) || null
						);

						// Skills
						if (jobDetails?.skills && jobDetails?.skills.length > 0) {
							const skills = Array.isArray(jobDetails?.skills)
								? jobDetails?.skills
								: String(jobDetails?.skills).split(',').map(Number);
							setSelectedSkills(SKILLS_LIST.filter(skill => jobDetails?.skills.includes(skill.id)));
						}
						
					}
				}
			} catch (error) {
				console.error("Error fetching data:", error);
				setAlert({
					open: true,
					message: "Failed to load profile data",
					severity: "error"
				});
			}
		};

		if (token) {
			fetchAllData();
		}
	}, []);
	const handleContinue = async () => {
		if (!validateForm()) {
			setAlert({
				open: true,
				message: "Please fill all required fields",
				severity: "error",
			});
			return;
		}

		try {
			// Save form data to localStorage
			setFormData("education", {
				education: selectedEducation,
				university: selectedUniversity,
				workingLocation,
				// ...other fields...
			});
			const newJobFormData = {
				"designationId": selectedDesignation?.id || null,
				"companyName": workingCompany || null,
				"workingLocationName": workingLocation || null,
				"workingSince": workingSince ? workingSince?.format("YYYY-MM-DD") : null,
				"totalExperience": totalExperience || null,
				"colleagueNameAndmobileNumber": colleaguesInfo || null,
				"annualIncome": annualIncome ? Number(annualIncome) : null,
				"propertyDetails": propertyDetails || null,
				"employedIn": selectedEmployedIn ? selectedEmployedIn?.id : null,
				"currentEmployer": currentEmployer || null,
				"previousEmployer": previousEmployer || null,
				"skills": selectedSkills.map((skill) => skill.id),
				"healthCondition": healthCondition?.id || null,
				"officeLocation": officeLocation || null,
				"passportNumber": passportNumber || null,
				"visaTypeId": visaType ? visaType?.id : null,
				"visaEndDate": visaValidityTill ? visaValidityTill?.format("YYYY-MM-DD") : null,
				"visaValidDate": visaValidityFrom ? visaValidityFrom?.format("YYYY-MM-DD") : null,
				// // "countryId":countries?.id || null,
				// "countryId": selectedCountry?.id || null,
				// // "stateId": selectedState?.id || null,
				// "stateId": selectedState?.id
				// 	|| profileData?.jobDetails?.state?.id
				// 	|| null,
				// // "districtId":selectedDistrict?.id || null,
				"districtId": selectedDistrict?.id
					|| profileData?.jobDetails?.district?.id
					|| null,
				"countryId":countries?.id || null,
				"stateId": selectedState?.id || null,
				employedStatus: selectedEmployedStatus ? selectedEmployedStatus?.name : ""
			}
			let newEducationPayload = {
				"education_id": selectedEducation?.id || null,
				"university_id": selectedUniversity?.id || null,
				"profession": selectedProfession?.id || null,
				"institutionName": instituteName || null,
				aboutEducation: aboutEducation ? aboutEducation : "",

			}
			const response = await updateEducationDetails(newEducationPayload);

			if (!response.status) {
				setAlert({
					open: true,
					message: response.message,
					severity: "error",
				});
				return;
			}
			const jobDetailsResponse = await updateNewJobDetails(newJobFormData);
			if (!jobDetailsResponse.status) {
				setAlert({
					open: true,
					message: jobDetailsResponse.message,
					severity: "error",
				});
				return;
			}
			setAlert({
				open: true,
				message: "Education details updated successfully",
				severity: "success",
			});

			setTimeout(() => {
				if (type != "edit") {
					navigate("/profile/family");
				}else{
					onSubmitSuccess?.();
				}
			}, 1000);
		} catch (error) {
			setAlert({
				open: true,
				message: error.message || "Failed to update education details",
				severity: "error",
			});
		}
	};
	const validateForm = () => {
		const newErrors = {};

		// Required fields validation
		let requiredFields = {
			// selectedEducation: "Education",
			// selectedUniversity: "University",
			selectedEmployedStatus: "Employed Status",
			selectedEmployedIn: "Employed In",
			selectedDesignation: "Designation",
			selectedProfession: "Profession",
			workingLocation: "Working Location",
			// workingCompany : "Company Name",
			// officeLocation : "Company Address"
		};

		if (selectedEmployedStatus?.name == "Un Employed") {
			requiredFields = {}
			return true
		}

	

		// Specific validations
		if (workingLocation === "abroad") {
			if (!selectedCountry) newErrors.selectedCountry = "Country is required";
			if (!selectedState) newErrors.selectedState = "State is required";
			// if (!visaType) newErrors.visaType = "Visa type is required";
			if (!passportNumber)
				newErrors.passportNumber = "Passport number is required";
			if (!visaValidityFrom)
				newErrors.visaValidityFrom = "Visa validity from date is required";
			if (!visaValidityTill)
				newErrors.visaValidityTill = "Visa validity till date is required";
		}

		// if (workingLocation === "india") {
		// 	if (!selectedState) newErrors.selectedState = "State is required";
		// }

		// Validate annual income
		if (!annualIncome) {
			newErrors.annualIncome = "Annual income is required";
		} else if (isNaN(annualIncome)) {
			newErrors.annualIncome = "Annual income must be a number";
		}
	Object.entries(requiredFields).forEach(([field, label]) => {
			if (!eval(field)) {
				newErrors[field] = `${label} is required`;
			}
		});
		setErrors(newErrors);
		return Object.keys(newErrors).length === 0;
	};
	const getDestictsData = async (id) => {

		try {
			const response = await getDistrictsListByState(id); // Pass state ID
			if (response.status) {
				setDistricts(response.data);
			}
		} catch (error) {
			console.error("Error fetching districts:", error);
		}
	}
	const changeSelectedState = async (newValue) => {
		setSelectedState(newValue)
		const districtsResponse = await getDistrictsListByState(newValue?.id);
		if (districtsResponse.status) {
			setDistricts(districtsResponse.data);

			setSelectedDistrict(
				null
			)

		}
	}
	const handleWorkingLocationChange = (e) => {
		setWorkingLocation(e.target.value);
		// Reset related fields when location changes
		if (e.target.value === "india") {
			setSelectedCountry(null);
			setVisaType(null);
			setVisaValidityFrom(null);
			setVisaValidityTill(null);
			setPassportNumber("");
		}
	};

	// Update country change handler
	const handleCountryChange = async (event, newValue) => {
		setSelectedCountry(newValue);
		setSelectedState(null);
		setSelectedDistrict(null);
		setStates([]);
		// setDistricts([]);

		if (newValue?.id) {
			try {
				const response = await getStatesListByCountry(newValue?.id);
				if (response.status) {
					const countryStates = response.data.filter(
						(state) => state.country?.id === newValue.id
					);
					console.log(response.data);

					setStates(response.data);
				}
			} catch (error) {
				console.error("Error fetching states:", error);
			}
		}
	};
	// Update state change handler
	console.log("country:", countries);  // should log { id: 1, name: "India" } or similar

	const handleStateChange = async (event, newValue) => {
		await getDestictsData(newValue.id)
		setSelectedState(newValue);
	};

	useEffect(() => {
		const fetchStatesForIndia = async () => {
			if (workingLocation === "india") {
				try {
					const response = await getStatesList(1); // Pass countryId 1 for India
					if (response.status) {
						setStates(response.data);
					}
				} catch (error) {
					console.error("Error fetching Indian states:", error);
				}
			} else {
				try {
					const response = await getVisaTypes(); // Pass countryId 1 for India
					if (response.status) {
						setVisaTypes(response.data);
					}
				} catch (error) {
					console.error("Error fetching Indian states:", error);
				}
			}
		};

		fetchStatesForIndia();
	}, [workingLocation, type]);


	const renderLocationFields = () => {
		if (workingLocation === "india") {
			return (
				<>
					<Autocomplete
						options={states}
						getOptionLabel={(option) => option.stateName}
						value={
							selectedState ||
							states.find((item) => item.id === profileData?.jobDetails?.state?.id) ||
							null
						}
						onChange={(event, newValue) => changeSelectedState(newValue)}
						renderInput={(params) => (
							<StyledTextField
								{...params}
								label="Working State"
								variant="outlined"
								size="small"
								error={!!errors.selectedState}
								helperText={errors.selectedState}
							/>
						)}
					/>

					<Autocomplete
						options={districts}
						getOptionLabel={(option) => option.districtName}
						// value={
						// 	selectedDistrict
						// }
						value={
							selectedDistrict ||
							districts.find((item) => item.id === profileData?.jobDetails?.district?.id) || null}
						onChange={(event, newValue) => setSelectedDistrict(newValue)}
						renderInput={(params) => (
							<StyledTextField
								{...params}
								label="Select City/District"
								variant="outlined"
								size="small"
								error={!!errors.selectedDistrict}
								helperText={errors.selectedDistrict}
							/>
						)}
					/>

					<LocalizationProvider dateAdapter={AdapterDayjs}>
						<DatePicker
							label="Working Since"
							value={workingSince}
							onChange={(newValue) => setWorkingSince(dayjs(newValue))}
							slotProps={{
								textField: {
									fullWidth: true,
									size: "small",
								},
							}}
						/>
					</LocalizationProvider>
					<StyledFormControl fullWidth size="small">
						<InputLabel>Total Experience</InputLabel>
						<Select
							label="Total Experience"
							value={totalExperience}
							onChange={(e) => setTotalExperience(e.target.value)}
						>
							<MenuItem value="0-1">0-1 years</MenuItem>
							<MenuItem value="1-3">1-3 years</MenuItem>
							<MenuItem value="3-5">3-5 years</MenuItem>
							<MenuItem value="5-10">5-10 years</MenuItem>
						</Select>
					</StyledFormControl>
					<StyledFormControl fullWidth size="small">
						<PhoneInput
							country={'in'}
							value={profileData?.jobDetails?.colleagueNameAndmobileNumber || colleaguesInfo}
							onChange={(phone) => setColleaguesInfo(phone)}
							inputStyle={{
								width: '100%',
								height: '40px',
							}}
						/>
					</StyledFormControl>


				</>
			);
		} else {
			return (
				<>
					<Autocomplete
						options={countries}
						getOptionLabel={(option) => option.countryName}
						value={
							selectedCountry ||
							countries.find((item) => item.id === profileData?.jobDetails?.country?.id) ||
							null
						}
						// value={selectedCountry}
						onChange={handleCountryChange}
						renderInput={(params) => (
							<StyledTextField
								{...params}
								label="Select Country"
								variant="outlined"
								size="small"
								error={!!errors.selectedCountry}
								helperText={errors.selectedCountry}
							/>
						)}
					/>


					<Autocomplete
						options={states}
						getOptionLabel={(option) => option.stateName}
						// value={selectedState}
						value={
							selectedState ||
							states.find((item) => item.id === profileData?.jobDetails?.state?.id) ||
							null
						}
						onChange={handleStateChange}
						renderInput={(params) => (
							<StyledTextField
								{...params}
								label="Select State"
								variant="outlined"
								size="small"
								error={!!errors.selectedState}
								helperText={errors.selectedState}
							/>
						)}
					/>
				

					<StyledTextField
						fullWidth
						label="Passport Number"
						value={passportNumber}
						onChange={(e) => setPassportNumber(e.target.value)}
						size="small"
						error={!!errors.passportNumber}
						helperText={errors.passportNumber}
					/>
					<Autocomplete
						options={visatypes}
						getOptionLabel={(option) => option.name}
						value={
							visaType
						}
						onChange={(event, newValue) => setVisaType(newValue)}
						renderInput={(params) => (
							<StyledTextField
								{...params}
								label="Visa Type"
								variant="outlined"
								size="small"
								error={!!errors.visaType}
								helperText={errors.visaType}
							/>
						)}
					/>
					<LocalizationProvider dateAdapter={AdapterDayjs}>
						<DatePicker
							label="Visa Valid From"
							value={visaValidityFrom}
							onChange={(newValue) => setVisaValidityFrom(dayjs(newValue))}
							sx={{ mb: 2 }}
							slotProps={{
								textField: {
									fullWidth: true,
									size: "small",
									error: !!errors.visaValidityFrom,
									helperText: errors.visaValidityFrom,
								},
							}}
						/>
					</LocalizationProvider>
					<LocalizationProvider dateAdapter={AdapterDayjs}>
						<DatePicker
							label="Visa Valid Till"
							value={visaValidityTill}
							onChange={(newValue) => setVisaValidityTill(dayjs(newValue))}
							slotProps={{
								textField: {
									fullWidth: true,
									size: "small",
									error: !!errors.visaValidityTill,
									helperText: errors.visaValidityTill,
								},
							}}
						/>
					</LocalizationProvider>
				</>
			);
		}
	};

	return (
		<Container
			maxWidth={false} sx={{ maxWidth: "none" }}
		>
			{type != "edit" && <Box
				sx={{
					display: "flex",
					justifyContent: "space-between",
					alignItems: "center",
					flexDirection: { xs: "column", md: "row" },
					px: { xs: 0, sm: 25 },
					py: { xs: 2 }
				}}
			>
				<Box sx={{ textAlign: { xs: "center", md: "left" }, mb: { xs: 2, md: 0 } }}>
					<img
						src="/images/Frame 148.png"
						alt="Logo"
						style={{
							maxWidth: "330px",
							width: "100%",
							height: "auto",
						}}
					/>
				</Box>
				<Box
					sx={{
						position: "relative",
						width: 180,
						height: 180,
						display: "flex",
						justifyContent: "center",
						alignItems: "center",
					}}
				>
					<CircularProgress
						variant="determinate"
						value={100}
						size={120}
						thickness={3}
						sx={{
							position: "absolute",
							color: "#F0E0D0",
						}}
					/>
					<CircularProgress
						variant="determinate"
						value={profileData?.profileStrength}
						size={120}
						thickness={3}
						sx={{
							position: "absolute",
							color: "#B56E2C",
						}}
					/>
					<Box sx={{ textAlign: "center" }}>
						<Typography sx={{ fontSize: "30px", color: "#B56E2C" }}>{profileData?.profileStrength}%</Typography>
						<Typography sx={{ color: "#B56E2C" }}>completed</Typography>
					</Box>
				</Box>
			</Box>}

			<FormContainer elevation={0} sx={{ ...styles.formCard }}>
				<DecorativeCorner
					sx={{ top: -20, left: -20, transform: "rotate(0deg)" }}
				/>
				<DecorativeCorner
					sx={{ top: -20, right: -20, transform: "rotate(0deg)" }}
				/>
				<DecorativeCorner
					sx={{ bottom: -20, right: -20, transform: "rotate(0deg)" }}
				/>
				<DecorativeCorner
					sx={{ bottom: -20, left: -20, transform: "rotate(0deg)" }}
				/>

				<div className="form-content">
					
					<div style={{display:"flex",justifyContent:"space-between"}}>
										<Typography variant="h6" style={styles.formTitle}>
						Education Details
					</Typography>
					{(type != "edit" && profileData?.profileStrength >= 65) && <Button
					variant="outlined"
					color="secondary"
					sx={{ ...styles.skipButton }}
					onClick={() => {
						window.location.href = "/profile/DetaliesDashbord?type=suggested-profiles";
					}}


					>
					Skip
					</Button>}
					</div>
					<FormGrid>
						<StyledFormControl fullWidth size="small">
							<Autocomplete
								options={educationList}
								getOptionLabel={(option) => option.educationName}
								value={selectedEducation}
								onChange={(event, newValue) => {
									setSelectedEducation(newValue);
								}}
								renderInput={(params) => (
									<TextField
										{...params}
										label="Education"
										variant="outlined"
										size="small"
										error={!!errors.selectedEducation}
										helperText={errors.selectedEducation}
									/>
								)}
							/>
						</StyledFormControl>

						<StyledFormControl fullWidth size="small">
							<Autocomplete
								options={universities}
								getOptionLabel={(option) => option.univercityName}
								value={selectedUniversity}
								onChange={(event, newValue) => {
									setSelectedUniversity(newValue);
								}}
								renderInput={(params) => (
									<TextField
										{...params}
										label="University"
										variant="outlined"
										size="small"
										error={!!errors.selectedUniversity}
										helperText={errors.selectedUniversity}
									/>
								)}
							/>
						</StyledFormControl>


						<StyledFormControl>
							<TextField
								fullWidth
								label="Institution Name"
								variant="outlined"
								size="small"
								value={instituteName}
								onChange={(e) => setInstituteName(e.target.value)}
							/>
						</StyledFormControl>
						{/* <Grid item xs={12}> */}
						<StyledTextField
							fullWidth
							label="About Your Educational Details"
							multiline
							rows={3}
							value={aboutEducation}
							onChange={(e) => setAboutEducation(e.target.value)}
							size="small"
						// error={!!errors.aboutMe}
						// helperText={errors.aboutMe}
						/>
						{/* </Grid> */}
					</FormGrid>

					<Typography variant="h6" style={styles.formTitle}>
						Job Details
					</Typography>
					<FormGrid>
						<StyledFormControl fullWidth size="small">
							<Autocomplete
								options={workingStatus}
								getOptionLabel={(option) => option?.name || ""}
								value={selectedEmployedStatus}
								isOptionEqualToValue={(option, value) =>
									option?.id === value?.id
								}
								onChange={(event, newValue) => {
									setSelectedEmployedStatus(newValue);
								}}
								renderInput={(params) => (
									<TextField
										{...params}
										label="Employed Status"
										variant="outlined"
										size="small"
										error={!!errors.selectedEmployedStatus}
										helperText={errors.selectedEmployedStatus}
									/>
								)}
							/>
						</StyledFormControl>
						{selectedEmployedStatus?.name != "Un Employed" && <>
							<StyledFormControl fullWidth size="small">
								<Autocomplete
									options={professions}
									getOptionLabel={(option) => option.professionName}
									value={selectedProfession}
									onChange={(event, newValue) => {
										setSelectedProfession(newValue);
									}}
									renderInput={(params) => (
										<TextField
											{...params}
											label="Profession"
											variant="outlined"
											size="small"
											error={!!errors.selectedProfession}
											helperText={errors.selectedProfession}
										/>
									)}
								/>
							</StyledFormControl>
							<Autocomplete
								options={employedInList}
								getOptionLabel={(option) => option?.name || ""}
								value={selectedEmployedIn}
								onChange={(event, newValue) => setSelectedEmployedIn(newValue)}
								renderInput={(params) => (
									<StyledTextField
										{...params}
										label="Employed In"
										variant="outlined"
										size="small"
										error={!!errors.selectedEmployedIn}
										helperText={errors.selectedEmployedIn}
									/>
								)}
							/>
							<StyledFormControl fullWidth size="small">
								<Autocomplete
									options={designations}
									getOptionLabel={(option) => option?.designationName || ""}
									value={selectedDesignation}
									isOptionEqualToValue={(option, value) =>
										option?.id === value?.id
									}
									onChange={(event, newValue) => {
										setSelectedDesignation(newValue);
									}}
									renderInput={(params) => (
										<TextField
											{...params}
											label="Designation"
											variant="outlined"
											size="small"
											error={!!errors.selectedDesignation}
											helperText={errors.selectedDesignation}
										/>
									)}
								/>
							</StyledFormControl>
							<StyledFormControl fullWidth size="small">
								<TextField
									fullWidth
									label="Company Name"
									value={workingCompany}
									onChange={(e) => setWorkingCompany(e.target.value)}
									size="small"
								/>
							</StyledFormControl>
							<StyledFormControl fullWidth size="small">
								<InputLabel>Working Location</InputLabel>
								<Select
									label="Working Location"
									value={workingLocation}
									onChange={handleWorkingLocationChange}
								>
									<MenuItem value="india">India</MenuItem>
									<MenuItem value="abroad">Abroad</MenuItem>
								</Select>
							</StyledFormControl>

							{renderLocationFields()}
							<StyledTextField
								fullWidth
								label="Annual Income in Lakhs"
								value={annualIncome}
								onChange={(e) => setAnnualIncome(e.target.value)}
								size="small"
								error={!!errors.annualIncome}
								helperText={errors.annualIncome}
							/>



							{selectedEmployedIn?.id != 3 && <StyledTextField
								fullWidth
								label="Previous Employer"
								value={previousEmployer}
								onChange={(e) => setPreviousEmployer(e.target.value)}
								size="small"
							/>}

							<StyledTextField
								fullWidth
								label="Current Employer"
								value={currentEmployer}
								onChange={(e) => setCurrentEmployer(e.target.value)}
								size="small"
							/>






							{/* <StyledFormControl fullWidth size="small"> */}
							{/* <InputLabel>Health Condition</InputLabel>
							<Select
								value={healthCondition}
								onChange={(e) => setHealthCondition(e.target.value)}
								label="Health Condition"
							>
								{healthConditionsList && healthConditionsList.length > 0 ? (
									healthConditionsList.map((condition) => (
										<MenuItem key={condition.id} value={condition.id}>
											{condition.name}
										</MenuItem>
									))
								) : (
									<MenuItem value="">Loading options...</MenuItem>
								)}
							</Select> */}
							{/* <Autocomplete
								options={healthConditionsList}
								getOptionLabel={(option) => option.name}
								value={
									healthCondition ||
									healthConditionsList.find(
										(item) => item.id === profileData?.jobDetails?.healthCondition
									) ||
									null
								}
								onChange={(event, newValue) => {
									setHealthCondition(newValue);
								}}
								renderInput={(params) => (
									<TextField
										{...params}
										label="Health Condition"
										variant="outlined"
										size="small"
										error={!!errors.healthCondition}
										helperText={errors.healthCondition}
									/>
								)}
							/>

						</StyledFormControl> */}
							<StyledTextField
								fullWidth
								label="Office Location Address"
								value={officeLocation}
								onChange={(e) => setOfficeLocation(e.target.value)}  // This will update the state
								size="small"
								multiline
								rows={2}
							/>
							<StyledTextField
								fullWidth
								label="Property Details"
								value={propertyDetails}
								onChange={(e) => setPropertyDetails(e.target.value)}
								size="small"
								multiline
								rows={2}
							/>
							
							<Autocomplete
								multiple
								options={SKILLS_LIST}
								getOptionLabel={(option) => option.name}
								value={
									selectedSkills.length > 0
										? selectedSkills
										: SKILLS_LIST.filter((item) => skillIds.includes(item.id))
								}
								onChange={(event, newValue) => setSelectedSkills(newValue)}
								renderInput={(params) => (
									<StyledTextField
										{...params}
										label="Skills"
										variant="outlined"
										size="small"
									/>
								)}
							/>

						</>}
						{selectedEmployedStatus?.name != "Employed" && <StyledTextField
							fullWidth
							label="Property Details"
							value={propertyDetails}
							onChange={(e) => setPropertyDetails(e.target.value)}
							size="small"
							multiline
							rows={2}
						/>}
					</FormGrid>

					<StyledButton
						variant="contained"
						onClick={handleContinue}
						sx={{
							width: { xs: "100%", sm: "160px" },
							marginTop: { xs: 3, md: 4 },
							padding: "15px 0px",
						}}
					>
						Save & Continue
					</StyledButton>

					<CustomAlert
						open={alert.open}
						message={alert.message}
						severity={alert.severity}
						onClose={() => setAlert({ ...alert, open: false })}
					/>
				</div>
			</FormContainer>
		</Container>
	);
};

export default EducationJobForm;

